// 图都用的cdn, 传图的地方在【模板中心 - 工具 - S3】http://tpl.tbox.me/dashboard
export const AssetImageUrl = {
	"ic_back@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b74043_ic_back@3x.png",
	"ic_closed@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b78422_ic_closed@3x.png",
	"ic_Help Center1@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b74c79_ic_Help Center1@3x.png",
	"ic_menu@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b7b4ad_ic_menu@3x.png",
	"ic_My Account1@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b77dc2_ic_My Account1@3x.png",
	"ic_My Favorites@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9b77894_ic_My Favorites@3x.png",
	"ic_My Orders@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9bd0a71_ic_My Orders@3x.png",
	"ic_next@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9bd41a1_ic_next@3x.png",
	"ic_search@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc85e9bd4bc5_ic_search@3x.png",
	"tabbar_ic_account@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc87aebe008f_tabbar_ic_account@3x.png",
	"tabbar_ic_cart@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc87aebe002a_tabbar_ic_cart@3x.png",
	"tabbar_ic_center@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc87aebe267b_tabbar_ic_center@3x.png",
	"tabbar_ic_home@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc87aec17a90_tabbar_ic_home@3x.png",
	"ic_箭头@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc8801390d78_ic_箭头@3x.png",
	"ic_closed2@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc8801390ced_ic_closed2@3x.png",
	"ic_deleted@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc88013e6fc1_ic_deleted@3x.png",
	"ic_right@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc88013e4b51_ic_right@3x.png",
	"instagram@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc88013e83fa_instagram@3x.png",
	"like@3x.png": "https://li0.rightinthebox.com/images/upload/202012/5fc8801411f58_like@3x.png",
	"ic_clear@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fc8801418fda_ic_clear@3x.png",
	"bg@3x.png": "https://li0.rightinthebox.com/images/upload/202012/5fd191110a907_bg@3x.png",
	"ic_download@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fd1911105115_ic_download@3x.png",
	"ic_time@3x.png":
		"https://li0.rightinthebox.com/images/upload/202012/5fd19110f0757_ic_time@3x.png",
	"logo@3x.png": "https://li0.rightinthebox.com/images/upload/202012/5fd19110ef803_logo@3x.png",
	m_head_logo: require("./images/logo.png"),
	// PC 专属
	pc_logo:
		"https://li0.rightinthebox.com/images/dfp/fs-images/2022/466e1545653c69eb37f2808363e244b3.jpg",
	pc_app: "https://li0.rightinthebox.com/images/upload/202101/5ffff30aa61dd_icons.png",
	pc_flag:
		"https://li0.rightinthebox.com/images/upload/202101/60000fa9da688_flag_4ce9318c061ec387.png",
	pc_account: "https://li0.rightinthebox.com/images/upload/202101/6001403d14369_user_b.png",
	pc_account_active:
		"https://li0.rightinthebox.com/images/upload/202101/60014126486ed_user_b (1).png",
	pc_like: "https://li0.rightinthebox.com/images/upload/202101/600540d7defbb_like_b.png",
	pc_like_active:
		"https://li0.rightinthebox.com/images/upload/202101/600540dcb8abc_like_b (1).png",
	pc_cart: "https://li0.rightinthebox.com/images/upload/202101/6005486c261a1_shopcart_b.png",
	pc_cart_active:
		"https://li0.rightinthebox.com/images/upload/202101/60054893767bb_shopcart_b (2).png",
	pc_cart_empty: require("./images/pc_cart_empty.png"),
	pc_search: "https://li0.rightinthebox.com/images/upload/202101/60094e26ef967_search_14.png",
	pc_arrow: "https://li0.rightinthebox.com/images/upload/202101/600fec8537674_nextarrow.png",
};
